import blackHoodie from './images/black-hoodie.png';
import whiteHoodie from './images/white-hoodie.png';
import tshirt from './images/t-shirt.png';
import tanktop from './images/tanktop.png';

const productList = [
  {
    id: 1,
    img: blackHoodie,
    title: 'Black OG Bball hoodie',
    price: 29.99
  },
  {
    id: 2,
    img: whiteHoodie,
    title: 'White OG Bball hoodie',
    price: 27.99
  },
  {
    id: 3,
    img: tshirt,
    title: 'White OG Bball t-shirt',
    price: 20.99
  },
  {
    id: 4,
    img: tanktop,
    title: 'White OG Bball tank-top',
    price: 17.99
  }
];

export default productList;